import {ReactComponent as Upload} from '../../../assets/icons/upload.svg'
import {ReactComponent as TextFields} from '../../../assets/icons/text_fields.svg'
import {ReactComponent as LayersIcon} from '../../../assets/icons/all-layers.svg'
import {ReactComponent as ShapesIcon} from '../../../assets/icons/shapes.svg'

export const SIDEBAR_ITEM_IDS = {
    ADD_IMAGE: 'addImage',
    ADD_TEXT: 'addText',
    LAYERS: 'layers',
    SHAPES: 'shapes',
    DEVTOOLS: 'devtools',
}

export const sidebarConfig = [
    {
        id: SIDEBAR_ITEM_IDS.ADD_IMAGE,
        action: 'addImage',
        label: 'Add image',
        icon: Upload,
        panelId: null,
    },
    {
        id: SIDEBAR_ITEM_IDS.ADD_TEXT,
        action: 'addText',
        label: 'Add text',
        icon: TextFields,
        panelId: null,
    },
    {
        id: SIDEBAR_ITEM_IDS.LAYERS,
        action: 'togglePanel',
        label: 'Layers',
        icon: LayersIcon,
        panelId: 'layers',
    },
    {
        id: SIDEBAR_ITEM_IDS.SHAPES,
        action: 'togglePanel',
        label: 'Shapes',
        icon: ShapesIcon,
        panelId: 'shapes',
    },
    {
        id: SIDEBAR_ITEM_IDS.DEVTOOLS,
        action: 'togglePanel',
        label: 'DevTools',
        icon: null,
        panelId: 'devtools',
        visibleWhen: 'devTools',
    },
]
